import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { injectIntl } from 'react-intl'
import { Select } from 'core/components/ui'

import { greys } from 'assets/themes/theme-default'
import FilterTitle from '../title'

const SelectWrapper = styled.div`
  margin-bottom: 15px;
`
const StyledSelect = styled(Select)`
  width: 100%;
  &.ant-select-focused,
  &.ant-select-active {
    .ant-select-selection {
      border-color: ${props => props.theme.colors.color1.bg};
    }
  }
  .ant-select-selection {
    background: ${greys.light3};
    :hover {
      border-color: ${props => props.theme.colors.color1.bg};
    }
  }
`

const { Option } = Select

const MakeModel = props => {
  /* getFilterBrands = () => {
    const params = {}
    RequesterStock.get(requesterStockMethods.GET_BRANDS, params)
      .then(datas => {
        const { stock, setStock } = this.props
        const { filtersList } = stock

        const extendedFiltersList = {
          ...filtersList,
          makesList: datas.makes
        }

        const extendedStock = {
          ...stock,
          filtersList: extendedFiltersList
        }

        setStock(extendedStock)
      })
      .catch(e => message.error(e))
      .finally(() => {
        this.setState({ loadingBrands: false })
      })
  }
*/
  /* getFilterModels = () => {
    const params = {}
    RequesterStock.get(requesterStockMethods.GET_MODELS, params)
      .then(datas => {
        const { stock, setStock } = this.props
        const { filtersList } = stock

        const extendedFiltersList = {
          ...filtersList,
          modelsList: datas.models
        }

        const extendedStock = {
          ...stock,
          filtersList: extendedFiltersList
        }

        setStock(extendedStock)
      })
      .catch(e => message.error(e))
      .finally(() => {
        this.setState({ loadingModels: false })
      })
  }
*/

  const { intl, loading, onChangeFilter, filters, filtersDatas } = props

  const { makes, models } = filters
  const makesList = filtersDatas.makes
  const modelsList = filtersDatas.models

  const handleOnChangeFiltreBrand = value => {
    const extendedFiltersValues = {
      ...filters,
      makes: value
    }

    onChangeFilter(extendedFiltersValues)
  }

  const handleOnChangeFiltreModel = value => {
    const extendedFiltersValues = {
      ...filters,
      models: value
    }
    onChangeFilter(extendedFiltersValues)
  }

  return (
    <div data-test="component-stock-vehicles-list-filters-brandModel">
      <FilterTitle
        label={intl.formatMessage({
          id: 'stock-vehicles-list-filters-brand-model-title'
        })}
        data-test="stock-vehicles-list-filters-brandModel-title"
      />
      <SelectWrapper>
        <StyledSelect
          loading={loading}
          disabled={loading}
          placeholder={intl.formatMessage({
            id: 'stock-vehicles-list-filters-brand-model-placeholder-1'
          })}
          onChange={value => handleOnChangeFiltreBrand(value)}
          value={makes}
          mode="multiple"
          data-test="stock-vehicles-list-filters-brandModel-select-brand"
        >
          {makesList &&
            makesList.map(brand => (
              <Option
                value={brand.id}
                key={brand.id}
                data-test="stock-vehicles-list-filters-brandModel-select-brand-option"
              >
                {brand.wording}
              </Option>
            ))}
        </StyledSelect>
      </SelectWrapper>
      <SelectWrapper>
        <StyledSelect
          loading={loading}
          disabled={loading}
          placeholder={intl.formatMessage({
            id: 'stock-vehicles-list-filters-brand-model-placeholder-2'
          })}
          onChange={value => handleOnChangeFiltreModel(value)}
          value={models}
          mode="multiple"
          data-test="stock-vehicles-list-filters-brandModel-select-model"
        >
          {modelsList &&
            modelsList.map(model => (
              <Option
                value={model.id}
                key={model.id}
                data-test="stock-vehicles-list-filters-brandModel-select-model-option"
              >
                {model.wording}
              </Option>
            ))}
        </StyledSelect>
      </SelectWrapper>
    </div>
  )
}

MakeModel.propTypes = {
  filtersDatas: PropTypes.shape().isRequired,
  filters: PropTypes.shape().isRequired,
  onChangeFilter: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  intl: PropTypes.shape().isRequired
}

export default injectIntl(MakeModel)
